import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://impactinnovate.com";
const DEFAULT_TITLE =
  "Impact Technologies | Robotics, AI Labs, Automation & Technical Training";
const DEFAULT_DESCRIPTION =
  "Impact Technologies in Meerut delivers robotics and AI labs, industrial automation, software and electronics solutions, and technical training across India.";

const pageMetadata = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/about": {
    title: "About Impact Technologies | Technology Training & Solutions",
    description:
      "Learn about Impact Technologies, a Meerut-based provider of technical training, embedded systems, software, electronics and automation solutions.",
  },
  "/training": {
    title: "Robotics & Technical Training Programs | Impact Technologies",
    description:
      "Explore practical robotics, embedded systems, programming and technical training programs from Impact Technologies for students and institutions.",
  },
  "/labs": {
    title: "Robotics & AI Lab Setup for Schools and Colleges | Impact Technologies",
    description:
      "Set up future-ready robotics and AI innovation labs for schools, colleges and universities with hands-on kits, equipment and training from Impact Technologies.",
  },
  "/automation": {
    title: "Industrial & Process Automation Solutions | Impact Technologies",
    description:
      "Impact Technologies provides tailored industrial, entrance and process automation solutions that improve efficiency for organisations across India.",
  },
  "/projects": {
    title: "Technology Projects & Solutions | Impact Technologies",
    description:
      "Discover technology, automation, software and electronics projects delivered by Impact Technologies.",
  },
  "/products": {
    title: "Technology Products & Robotics Kits | Impact Technologies",
    description:
      "Browse robotics, electronics, automation and technology products from Impact Technologies.",
  },
};

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);
}

export default function SEO() {
  const { pathname } = useLocation();
  const metadata = pageMetadata[pathname] || pageMetadata["/"];
  const canonicalUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

  useEffect(() => {
    document.title = metadata.title;
    setMeta('meta[name="description"]', "content", metadata.description);
    setMeta('meta[property="og:title"]', "content", metadata.title);
    setMeta('meta[property="og:description"]', "content", metadata.description);
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[name="twitter:title"]', "content", metadata.title);
    setMeta('meta[name="twitter:description"]', "content", metadata.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [canonicalUrl, metadata]);

  return null;
}
